module.exports = __webpack_public_path__ + "media/images/steps/svg/214-laptop-fe88cc00d0678bc8d36c07eeee693bd3.svg";